module.exports = {"341126100":"府城镇","341126101":"临淮关镇","341126102":"武店镇","341126103":"西泉镇","341126104":"官塘镇","341126105":"刘府镇","341126106":"大庙镇","341126107":"殷涧镇","341126108":"总铺镇","341126109":"红心镇","341126110":"板桥镇","341126111":"大溪河镇","341126112":"小溪河镇","341126113":"枣巷镇","341126201":"黄湾乡","341126400":"安徽凤阳经济开发区","341126401":"安徽凤阳硅工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341126.json
// module id = 1115
// module chunks = 0